export default __webpack_public_path__ + "static/media/info.2c17ee2f.svg";